<template>
    <div>
        {{name}}
    </div>
</template>

<script>
export default {
  data () {
        return {
        name:'vueApp'}
  }
}
</script>


